<template>
  <div class="iWorkWrap">
    <div class="mainTi">{{ $t('MODDER_VIEW.WORK_LOG') }}</div>
    <div class="iWorkCont">
      <!-- <div class="dimTemporarilyCome" v-if="modders[0].workLogImg == 0">Coming Soon...</div> -->
      <swiper
        :slidesPerView="2"
        :spaceBetween="5"
        :pagination="false"
        :navigation="true"
        :breakpoints="{
          '500': {
            slidesPerView: 3,
            spaceBetween: 5,
          },
          '768': {
            slidesPerView: 3,
            spaceBetween: 5,
          },
          '1024': {
            slidesPerView: 6,
            spaceBetween: 5,
          },
        }"
        :modules="modules"
        class="mySwiper iWorkBox"
      >
        <swiper-slide class="slide" v-for="pic in modders" :key="pic">
          <router-link :to="`/${$i18n.locale}/modderView/${pic.id}`" v-if="pic.workLogImg == 0" class="dimTemporarilyCome"><img src="@/assets/images/def.png" :alt="pic.modderSrc" height="125"></router-link>
          <router-link :to="`/${$i18n.locale}/modderView/${pic.id}`" v-else><img :src="imgWorkLog(pic.modderSrc)" :alt="pic.modderSrc" height="125"></router-link>
        </swiper-slide>
      </swiper>
      <!-- <div class="iWorkBox">

        <div class="slide" v-for="pic in modders" :key="pic">
          <a href="" title=""><img :src="imgWorkLog(pic.modderSrc)" alt="" width="175" height="125"></a>
        </div>
        <div class="slide"><a href="http://casemod.thermaltake.com/2021s1/modder_profile_3.html" title=""><img src="images/cler/1.jpg" alt="" width="175" height="125"></a></div>

      </div> -->
    </div>
  </div>
</template>

<style>
.iWorkBox .slide img {
  box-sizing: border-box;
}
/* 箭頭 */
.iWorkCont .swiper-button-prev, .iWorkCont .swiper-button-next {
  display: block;
  position: absolute;
  top: 50%;
  margin: -14px 0 0 0;
  width: 16px;
  height: 28px;
  text-indent: -9999px;
  background: url(@/assets/images/i_brand_left.png) no-repeat;
  cursor: pointer;
  -webkit-transition: .2s ease-in-out;
  transition: .2s ease-in-out;
}
.iWorkCont .swiper-button-prev:after, .iWorkCont .swiper-button-next:after {
  content: none;
}
.iWorkCont .swiper-button-next {
  background: url(@/assets/images/i_brand_right.png) no-repeat;
  left: inherit;
}
.dimTemporarilyCome, .dimTemporarilyCome img {
  width: auto;
  min-width: 189px;
}
@media screen and (max-width: 1024px) {
  .dimTemporarilyCome, .dimTemporarilyCome img {
    min-width: auto;
  }
}
</style>

<script>
import 'swiper/css'
import 'swiper/css/pagination'
import { Navigation, Pagination } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/vue'

export default {
  props: ['modders'],
  components: {
    Swiper,
    SwiperSlide
  },
  data () {
    return {

    }
  },
  setup () {
    return {
      modules: [Navigation, Pagination]
    }
  },
  methods: {
    imgWorkLog (item) {
      // return require(`../assets/images/${item}/1.jpg`)
      return `./images/${item}/1.jpg`
    }
  },
  created () {

  }
}
</script>
